import { z } from 'zod';

import { UuidSchema } from '../common/id/id';

/**
 * The client-reported app build that was on screen when consent was given.
 *
 * Free-form on purpose: mobile sends `1.4.2 (312)`, the admin portal sends its
 * Vite build id, and a future surface will send something else again. It is
 * evidence for a legal record, not a value the platform branches on, so
 * validating it into a shape would only reject honest reporters.
 */
export const AppVersionSchema = z.string().min(1).max(64);

/**
 * Accepting one or more legal versions (N16).
 *
 * A **batch**, because the consent screen shows every outstanding document at
 * once and a member ticking three boxes performs one act — accepting them one
 * request at a time would leave a half-consented member if the second call
 * failed, which is precisely the state the gate cannot describe.
 *
 * The **ip** is not here: it is read from the request server-side. A
 * client-supplied address in a legal record is worth less than no address.
 */
export const AcceptConsentSchema = z
  .object({
    versionIds: z.array(UuidSchema).min(1).max(50),
    appVersion: AppVersionSchema.optional(),
  })
  .strict();

export type AcceptConsentRequest = z.infer<typeof AcceptConsentSchema>;
